import Footer from "../components//Footer";
import React, {useState} from "react";
import MetaComponent from "../components/MetaComponent";
import Header from "../components/Header";
import Orders from "./Orders";
import OrderDetails from "./OrderDetails";
// import OrderDetails from "./OrderDetails";



const metadata = {
    title: `Account Orders || ${process.env.REACT_APP_META_TITLE}`,
    description: process.env.REACT_APP_META_DESCRIPTION,
};

export default function AccountOrderPage({ onPageReady }) {
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [orderLoading, setOrderLoading] = useState(false);
    return (
        <>
            <MetaComponent meta={metadata} />
            <Header />
            <Orders setSelectedOrder={setSelectedOrder} setOrderLoading={setOrderLoading} onLoaded={onPageReady}/>
            <Footer />
            <OrderDetails order={selectedOrder}  orderLoading={orderLoading}/>
        </>
    );
}
